// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

const {ccclass, property, executeInEditMode, menu} = cc._decorator;


/**
 * 数值变化类型
 */
enum AnimType {
    /** 以速度计算变化时长 */
    SPEED,
    /** 固定时长 */
    DURATION,
}

@ccclass
@executeInEditMode
@menu('Framework/UI组件/AnimValue')
export default class AnimValue extends cc.Component {

    @property private _endValue: number = 0;
    @property public _curValue: number = 0;
    @property public _initValue: number = 0;

    @property({
        tooltip: CC_DEV && '初始值'
    })
    private get InitValue(): number { return this._endValue; }
    private set InitValue(v: number) {
        this._initValue = v;
        this._curValue = v;
        this._endValue = v;
        this.setValueImmediately(this._endValue);
    }

    @property({
        type: cc.Enum(AnimType),
        tooltip: CC_DEV && '数值变化类型\nSPEED：以速度计算变化时长\nDURATION：固定时长'
    })
    public AnimType: AnimType = AnimType.SPEED;

    @property({
        tooltip: CC_DEV && '每秒数值变化速度',
        visible() { return this.AnimType === AnimType.SPEED; }
    })
    public Speed: number = 0.5;

    @property({
        tooltip: CC_DEV && '数值变化的总时长',
        visible() { return this.AnimType === AnimType.DURATION; }
    })
    public Duration: number = 1;

    /** 缓存动画的resolve */
    private _animResolve: (value: void | PromiseLike<void>) => void;

    private _tween: cc.Tween<AnimValue> = null;
     /** 当前是否为增量变化 */
    private _isAdd: boolean = false;
    /** 当前是否为增量变化 */
    public get isAdd(): boolean { return this._isAdd; }

    /** 变化的目标值 */
    public get endValue(): number { return this._endValue; }
    /** 变化过程的当前值 */
    public get curValue(): number { return this._curValue; }

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    /**
     * @virtual
     */
    protected onAnimStart(): void {
    }

    /**
     * @virtual
     */
    protected onAnimUpdate(): void {
    }

    /**
     * @virtual
     */
    protected onAnimComplete(): void {
        if (this._animResolve) {
            this._animResolve();
            this._animResolve = null;
        }
        if (this._tween) {
            this._tween.stop();
            this._tween = null;
        }
    }

    /**
     * 立即设置value，不执行动画
     * @virtual
     */
    protected setValueImmediately(end: number): void {
        this._isAdd = this._endValue - this._curValue > 0;
        this._endValue = end;
        this._curValue = end;
		this.onAnimStart();
		this.onAnimUpdate();
		this.onAnimComplete();
    }

    /**
     * 设置进度值。异步方法，进度动画结束后resolve
     * @virtual
     * @param end 目标进度值
     * @param anim 是否执行动画，默认true
     */
    public async setValue(
        end: number
        , bProgress: boolean = true
        , anim: boolean = true
    ): Promise<void> {
        if (bProgress) {
            end = Math.min(1, Math.max(0, end));
        }
        if (!anim) {
            this.setValueImmediately(end);
            return;
        }
        let self = this;

        return new Promise((resolve, reject) => {
            self._animResolve = resolve;
            self._endValue = end;
            self._isAdd = self._endValue - self._curValue > 0;
            self._tween?.stop();
            let duration = self.AnimType === AnimType.DURATION 
                ? self.Duration : Math.abs(self._endValue - self._curValue) / self.Speed;

            self.onAnimStart();
            self._tween = cc.tween<AnimValue>(self)
                .to(duration, {
                    _curValue: end
                }, {
                    onUpdate: (current: any, percent: number) => {
                        self.onAnimUpdate();
                    }}
                )
                .call(()=> {
                    self.onAnimComplete();
                })
                .start();
        });
    }

    /**
     * 停止动画，并中止之前未结束的Promise
     * @virtual
     */
    public stop(): void {
        if (this._animResolve) {
            this._animResolve = null;
        }
        if (this._tween) {
            this._tween.stop();
            this._tween = null;
        }
    }

    // update (dt) {}
}
